export const getLoading = (state) => state.loading;
export const getLang = (state) => state.lang;
